import { render } from "./profileModalComponent.vue?vue&type=template&id=404b73a9&scoped=true"
import script from "./profileModalComponent.vue?vue&type=script&lang=js"
export * from "./profileModalComponent.vue?vue&type=script&lang=js"

import "./profileModalComponent.vue?vue&type=style&index=0&id=404b73a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404b73a9"]])

export default __exports__